import general from "./general.json";
import errors from "./errors.json";
import auth from "./auth.json";
import venues from "./venues.json";
import placeholder from "./placeholder.json";
import units from "./units.json";
import stages from "./stages.json";
import equipment from "./equipment.json";
import infoBlock from "./infoBlock.json";
import contact from "./contact.json";
import place from "./place.json";
import file from "./file.json";
import image from "./image.json";
import a11y from "./a11y.json";
import calendar from "./calendar.json";
import bands from "./bands.json";
import bandSettings from "./bandSettings.json";
import profile from "./profile.json";
import subscription from "./subscription.json";
import company from "./company.json";
import event from "./event.json";
import admin from "./admin.json";
import members from "./members.json";
import bandAssets from "./bandAssets.json";
import permissions from "./permissions.json";
import document from "./document.json";

import eventBlock from "./eventBlocks/eventBlock.json";
import peopleBlock from "./eventBlocks/peopleBlock.json";
import scheduleBlock from "./eventBlocks/scheduleBlock.json";
import venueBlock from "./eventBlocks/venueBlock.json";
import guestlistBlock from "./eventBlocks/guestlistBlock.json";
import travelBlock from "./eventBlocks/travelBlock.json";
import accommodationBlock from "./eventBlocks/accommodationBlock.json";

import address from "./user/address.json";
import phoneNumber from "./user/phoneNumber.json";
import drivingPermit from "./user/drivingPermit.json";
import emergencyContact from "./user/emergencyContact.json";
import homeBase from "./user/homeBase.json";
import loyaltyProgram from "./user/loyaltyProgram.json";
import passport from "./user/passport.json";
import socialSecurityForm from "./user/socialSecurityForm.json";
import travelVisa from "./user/travelVisa.json";
import vehicle from "./user/vehicle.json";
import bodyPreferences from "./user/bodyPreferences.json";
import hotelPreferences from "./user/hotelPreferences.json";
import flightPreferences from "./user/flightPreferences.json";
import copyBlock from "./eventBlocks/copyBlock.json";
import apiKeys from "./apiKeys.json";

export const copy = {
  ...general,
  ...errors,
  ...auth,
  ...venues,
  ...placeholder,
  ...units,
  ...stages,
  ...equipment,
  ...infoBlock,
  ...contact,
  ...place,
  ...file,
  ...image,
  ...a11y,
  ...calendar,
  ...bands,
  ...bandSettings,
  ...profile,
  ...subscription,
  ...company,
  ...event,
  ...admin,
  ...members,
  ...bandAssets,
  ...permissions,
  ...eventBlock,
  ...peopleBlock,
  ...scheduleBlock,
  ...venueBlock,
  ...guestlistBlock,
  ...travelBlock,
  ...accommodationBlock,
  ...address,
  ...phoneNumber,
  ...drivingPermit,
  ...emergencyContact,
  ...homeBase,
  ...loyaltyProgram,
  ...passport,
  ...socialSecurityForm,
  ...travelVisa,
  ...vehicle,
  ...document,
  ...bodyPreferences,
  ...hotelPreferences,
  ...flightPreferences,
  ...copyBlock,
  ...apiKeys,
};
